(function () {
    'use strict';

    angular.module('ib-MmB-flights-card-module', [
        'ib-collapse'
    ]);
})();